import { createTheme } from '@mui/material';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0970af',
    },
    secondary: {
      main: '#868d93',
    },
    background: {
      default: '#ddd',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    error: {
      main: '#d32f2f',
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: 'Roboto, sans-serif',
    body1: {
      fontSize: 13,
    },
    body2: {
      fontSize: 13,
    },
    caption: {
      fontSize: 12,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      },
      defaultProps: {
        placement: 'top',
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'outlined',
        sx: {
          minWidth: '10px',
          px: 1,
        },
      },
      styleOverrides: {
        root: {
          variants: [
            {
              props: {
                variant: 'outlined',
              },
              style: {
                backgroundColor: 'white',
              },
            },
          ],
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled',
        fullWidth: true,
        margin: 'dense',
        size: 'small',
        autoComplete: 'off',
      },
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'filled',
        size: 'small',
        fullWidth: true,
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 210,
            },
          },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'filled',
        size: 'small',
        fullWidth: true,
      },
    },

    MuiCard: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiStepIcon: {
      defaultProps: {
        sx: {
          fontSize: '18px !important',
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        disableTypography: true,
      },
    },
    MuiCardContent: {
      defaultProps: {
        sx: {
          padding: '16px !important',
        },
      },
    },
    MuiCardActions: {
      defaultProps: {
        sx: {
          display: 'flex',
          justifyContent: 'flex-end !important',
          padding: '0 16px 16px 16px !important',
        },
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        sx: {
          fontSize: 18,
        },
      },
    },
    MuiDialogActions: {
      defaultProps: {
        sx: {
          padding: '0 16px 16px 16px !important',
        },
      },
    },
  },
});

// export const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#9e9e9e',
//     },
//     secondary: {
//       main: '#757575',
//     },
//     background: {
//       default: '#121212',
//       paper: '#1e1e1e',
//     },
//     text: {
//       primary: '#ffffff',
//       secondary: '#b0b0b0',
//     },
//   },
//   typography: {
//     fontSize: 13,
//   },
// });
